/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNewOrder } from '@/context/NewOrderContext';
import { firestore } from '@/lib/firebase/firebase';
import { TextField } from "__barrel_optimize__?names=TextField!=!@mui/material";
import { doc, updateDoc } from 'firebase/firestore';
import { MuiTelInput } from 'mui-tel-input';
import React from 'react';
function ContactInformation() {
    const { order, setOrder } = useNewOrder();
    const handleEmailBlur = async ()=>{
        if (!order.customer.email) return;
        try {
            const userSearchResponse = await fetch("/api/user?email=".concat(order.customer.email));
            if (!userSearchResponse.ok) {
                return;
            }
            const userData = await userSearchResponse.json();
            setOrder((prev)=>({
                    ...prev,
                    customer_id: userData.uid
                }));
        } catch (error) {
            console.error('Error fetching user by email:', error);
        }
    };
    const handleCustomerChange = async (field, value)=>{
        setOrder((prev)=>({
                ...prev,
                customer: {
                    ...prev.customer,
                    [field]: value
                }
            }));
        if (order.id) {
            const docRef = doc(firestore, 'orders', order.id);
            await updateDoc(docRef, {
                customer: {
                    ...order.customer,
                    [field]: value
                }
            });
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-10 flex flex-col gap-5",
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("span", {
                    className: "text-xl",
                    children: "Contact Information:"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "bg-neutral-100 p-5 rounded-xl",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-3",
                    children: [
                        /*#__PURE__*/ _jsx(TextField, {
                            value: order === null || order === void 0 ? void 0 : order.customer.first_name,
                            onChange: (e)=>handleCustomerChange('first_name', e.target.value),
                            fullWidth: true,
                            name: "first_name",
                            label: "First Name"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            value: order === null || order === void 0 ? void 0 : order.customer.last_name,
                            onChange: (e)=>handleCustomerChange('last_name', e.target.value),
                            fullWidth: true,
                            name: "last_name",
                            label: "Last Name"
                        }),
                        /*#__PURE__*/ _jsx(TextField, {
                            value: order === null || order === void 0 ? void 0 : order.customer.email,
                            onChange: (e)=>handleCustomerChange('email', e.target.value),
                            fullWidth: true,
                            name: "email",
                            label: "Email",
                            onBlur: handleEmailBlur
                        }),
                        /*#__PURE__*/ _jsx(MuiTelInput, {
                            value: order === null || order === void 0 ? void 0 : order.customer.phone,
                            onChange: (e)=>handleCustomerChange('phone', e),
                            onlyCountries: [
                                'US',
                                'CA'
                            ],
                            defaultCountry: "US",
                            name: "phone",
                            label: "Phone Number"
                        })
                    ]
                })
            })
        ]
    });
}
export default ContactInformation;
